import { useSelector } from '@xstate/react';
import { Button, IconStartAdornment } from 'components/Button';
import { ScheduleConfirmConsultationDate } from 'domains/signup/consultationSchedule/Steps/ConfirmConsultationDate';
import { ScheduleEnterConsultationDate } from 'domains/signup/consultationSchedule/Steps/EnterConsultationDate';
import { ScheduleContext } from 'domains/signup/consultationSchedule/data/ScheduleContext';
import { scheduleMachine, ScheduleState } from 'domains/signup/consultationSchedule/scheduleMachine';
import { signupStateChangeListener } from 'domains/signup/data/mixpanelTracking';
import { ScheduleLoadingStep } from 'domains/signup/sharedSteps/LoadingStep';
import { SignupContext, withSignupMachineState } from 'domains/signup/signupFlow/context/signupContext';
import { useTranslation } from 'react-i18next';
import { useEffectOnce } from 'react-use';
import { useActorUtilities } from 'utils/xstate/context';
import { ActorRefFrom } from 'xstate';

const EnteringSchedule: React.FC = () => {
  const scheduleActor = SignupContext.useSelector(
    state => state.children.runScheduleMachine as ActorRefFrom<typeof scheduleMachine>,
  );

  // Subscribe to log state changes with mixpanel
  useEffectOnce(() => {
    return scheduleActor.subscribe(({ value }) => {
      signupStateChangeListener(value as ScheduleState);
    }).unsubscribe;
  });

  const hasBack = useSelector(scheduleActor, state => state.can({ type: 'back' }));
  const { send } = scheduleActor;
  const { t } = useTranslation();

  return (
    <ScheduleContext.Provider value={useActorUtilities(scheduleActor)}>
      {hasBack && (
        <Button
          variant="link"
          startAdornment={<IconStartAdornment name="AngleLeft" />}
          className="mb-24"
          onClick={() => send({ type: 'back' })}
        >
          {t('screener.backButton')}
        </Button>
      )}
      <ScheduleEnterConsultationDate />
      <ScheduleConfirmConsultationDate />
      <ScheduleLoadingStep />
    </ScheduleContext.Provider>
  );
};

export const SignupEnteringSchedule = withSignupMachineState(EnteringSchedule, 'enteringSchedule');
